<template>
  <div class="nav">
    <nav class="App-nav" :class="[{ opened: opened }]">
      <div class="menu-container" ref="menuContainer">
        <div class="menu-content">
          <ul class="menu">
            <li v-for="(v, i) in menu" :key="i">
              <router-link
                active-class="current"
                :to="v.href"
                tag="a"
                :href="v.href"
                ref="menuItems"
                v-html="v.title"
                @mouseover.native="
                  () => {
                    onMouseOver(i);
                  }
                "
                @mouseout.native="
                  () => {
                    onMouseOut(i);
                  }
                "
              ></router-link>
            </li>
          </ul>
        </div>
        <div class="copyright" v-if="copyright" v-html="copyright"></div>
      </div>
    </nav>
    <div
      class="menu-buttons"
      :class="[{ opened: opened }]"
      v-if="!hideHamburger"
    >
      <hamburger
        class="hamburger"
        :stroke="2"
        :gap="3"
        color="#FFA737"
        :width="14"
        :open.sync="opened"
      ></hamburger>
    </div>
  </div>
</template>

<script>
import "vue-hamburger/index.css";
import hamburger from "vue-hamburger";
import { clearTimeout } from "timers";
export default {
  name: "Nav",
  props: {
    copyright: String,
    menu: Array,
    pageId: Number,
    hideHamburger: Boolean,
  },
  data() {
    return {
      opened: false,
      current: 0,
      timer: 0,
    };
  },
  watch: {
    opened(val) {
      if (val) {
        document.body.classList.add("stop-scrolling");
      } else {
        document.body.classList.remove("stop-scrolling");
      }
    },
  },
  computed: {
    submenu() {
      return this.menu[this.current].subMenu;
    },
  },
  mounted() {
    const el = this.$refs.menuItems[this.pageId].$el;
    this.$refs.menuContainer.scrollTo(
      el.getBoundingClientRect().x -
        this.$refs.menuContainer.clientWidth / 2 +
        el.clientWidth / 2,
      0
    );
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .addEventListener("scroll", this.onScroll);
    }
  },
  beforeDestroy() {
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .removeEventListener("scroll", this.onScroll);
    }
  },
  methods: {
    onClick() {
      document.body.classList.remove("stop-scrolling");
    },
    onScroll() {
      this.shadow = 0.2 * (window.scrollY.clamp(0, 800) / 800);
    },
    showContacts() {
      this.$emit("contacts");
    },
    onMouseOver(index) {
      this.current = index;
      clearTimeout(this.timer);
    },
    onMouseOut() {
      // this.timer = setTimeout(() => {
      //   this.current = this.pageId;
      // }, 500);
    },
  },
  components: {
    hamburger,
  },
};
</script>

<style lang="scss">
.nav {
  .App-nav {
    transition: right 0.2s, transform 0.2s;

    @media all and(max-width: $md) {
      position: fixed;
      top: 83px;
      width: 100vw;
      right: -100vw;
      transform: scale(0.5);
      height: calc(100vh - 83px);
      background: $color-accent;
      transform-origin: right top;
      align-items: flex-start;
    }
    display: grid;
    align-items: center;
    align-self: center;
    .menu-container {
      @media all and(max-width: $md) {
        align-self: stretch;
      }
      display: grid;
      grid-template-columns: 1fr;
      $scrollBarHeight: 1px;
      &::-webkit-scrollbar {
        width: $scrollBarHeight;
        height: $scrollBarHeight;
      }

      &::-webkit-scrollbar-button {
        width: $scrollBarHeight;
        height: $scrollBarHeight;
      }
      .menu-content {
        @media all and(max-width: $md) {
          padding: 0 14px;
        }
        ul.menu {
          @media all and(max-width: $lg) {
          }
          @media all and(max-width: $md) {
            margin-top: 71px;
            grid-gap: 24px;
            grid-auto-flow: row;
            justify-items: center;
            grid-template-columns: 1fr;
          }
          display: grid;
          justify-items: flex-end;
          grid-auto-flow: column;
          grid-auto-columns: max-content;
          margin-bottom: 0;
          grid-gap: 80px;

          li {
            @media all and(max-width: $md) {
              height: auto;
            }
            display: grid;
            justify-content: flex-start;
            height: 53px;
            align-items: flex-end;
            a {
              @media all and(max-width: $md) {
                font-size: 16px;
                color: $text-inverse-main;
                &:hover {
                  color: $text-main;
                }
              }
              @extend %nav-main;
              align-self: flex-end;
              color: $text-menu;
              border-bottom-width: 2px;
              border-bottom-color: transparent;
              &.router-link-exact-active {
                color: $text-menu-quart;
              }
              padding-bottom: 16px;
            }
          }
        }
      }
      .copyright {
        @media all and(max-width: $md) {
          display: grid;
        }
        display: none;
        align-items: flex-end;
        align-content: flex-end;
        padding-bottom: 47px;
        text-align: center;
        @extend %text-small;
      }
    }
    &.opened {
      @media all and(max-width: $md) {
        transform: scale(1);
      }
      z-index: 100;
      right: 0;
    }
  }
  .menu-buttons {
    @media all and (max-width: $lg) {
      &.opened {
        grid-row: 1;
        position: fixed;
      }
      @media all and(max-width: $md) {
        display: grid;
      }
      grid-row: 1;
      position: absolute;
      right: 26px;
      top: 28px;
      width: 36px;
      height: 36px;
      z-index: 1001;
    }
    display: none;
    .hamburger-button.hamburger {
      transition: all 0.2s;
      justify-self: center;
      align-self: center;
      margin-left: 0px;
      width: 36px !important;
      height: 36px !important;
      box-sizing: border-box;
      background: $color-error;
      border-radius: 10px;
      padding-top: 12px !important;
      &.open {
        margin-left: -2px;
        margin-top: -2px;
        width: 40px !important;
        height: 40px !important;
        background: $color-accent;
        border-radius: 50%;
        padding-top: 14px !important;
        padding-left: 13px !important;
        .line {
          height: 2px !important;
          width: 15px !important;
          background: $text-inverse-main !important;
        }
      }
    }
  }
}
</style>
